/**
 * 設定管理クラス
 * アプリケーション設定の保存・読み込みを管理
 */

import type { BaseManager } from './types'

export class SettingsManager implements BaseManager {
  constructor(public db: IDBDatabase | null) {}

  async setSetting(key: string, value: any): Promise<void> {
    if (!this.db) throw new Error('Database not initialized')

    return new Promise((resolve, reject) => {
      const transaction = this.db!.transaction(['settings'], 'readwrite')
      const store = transaction.objectStore('settings')
      const request = store.put({ key, value })

      request.onsuccess = () => resolve()
      request.onerror = () => reject(new Error('Failed to save setting'))
    })
  }

  async getSetting(key: string): Promise<any> {
    if (!this.db) throw new Error('Database not initialized')

    return new Promise((resolve, reject) => {
      const transaction = this.db!.transaction(['settings'], 'readonly')
      const store = transaction.objectStore('settings')
      const request = store.get(key)

      request.onsuccess = () => {
        const result = request.result
        resolve(result ? result.value : null)
      }
      request.onerror = () => reject(new Error('Failed to get setting'))
    })
  }
}